module.exports = __webpack_public_path__ + "files/eb43b226d56248f3735f616c818d159a.png";